import React from 'react';

import { Button, HEADER_BUTTON_DARK_BLUE } from '../../../components/PageHeader/Button';
import Strings from '../../../Strings';

export default function Fallback({ error, resetErrorBoundary }) {

  return (
    <div className="error-boundary-fallback">
      <p>{Strings.errors.somethingWentWrong}</p>
      <Button class={HEADER_BUTTON_DARK_BLUE} onClick={resetErrorBoundary} title={Strings.reload} />
    </div>
  );
}